module.exports = __webpack_public_path__ + "img/image12.83f0e275.png";